/** Buttons, chips, tags, avatars: full (pill). Inputs: md. Cards: lg. Sheets and dialogs: xl. */
export const radius = {
  none: '0',
  sm: '8px',
  md: '12px',
  lg: '20px',
  xl: '28px',
  full: '9999px',
} as const;
